namespace TabAurous.Purchase {
    export interface QuotationBOMForm {
        ItemTypeId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.LookupEditor;
        BOMProductId: Serenity.ServiceLookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BOMAttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ItemType: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        GroupSieveId: StoneSieveLookup;
        SieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        BomRate: AmountEditor;
        BomAmount: AmountEditor;
        CCBomAmount: AmountEditor;
        Remarks: Serenity.StringEditor;
        CostMethodId: Serenity.LookupEditor;
    }

    export class QuotationBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.QuotationBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QuotationBOMForm.init)  {
                QuotationBOMForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.StringEditor;
                var w6 = StoneSieveLookup;
                var w7 = s.DecimalEditor;
                var w8 = WeightEditor;
                var w9 = AmountEditor;

                Q.initFormType(QuotationBOMForm, [
                    'ItemTypeId', w0,
                    'ProductTypeId', w1,
                    'BOMProductId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BOMAttributeId', w5,
                    'ProductCode', w5,
                    'ItemType', w5,
                    'Attribute', w5,
                    'CertificateNo', w5,
                    'KaratId', w1,
                    'ShapeId', w1,
                    'StoneSizeId', w1,
                    'GroupSieveId', w6,
                    'SieveId', w6,
                    'MetalColorId', w1,
                    'StoneColorId', w1,
                    'QualityId', w1,
                    'SettingId', w1,
                    'StoneCutId', w1,
                    'StonePolishId', w1,
                    'StoneSymmetryId', w1,
                    'StoneFluorescenceId', w1,
                    'StoneCuletId', w1,
                    'StoneGirdleId', w1,
                    'StoneTable', w5,
                    'StoneDepth', w5,
                    'Purity', w7,
                    'Pieces', w0,
                    'Weight', w8,
                    'PureWeight', w7,
                    'CalcOnId', w1,
                    'BomRate', w9,
                    'BomAmount', w9,
                    'CCBomAmount', w9,
                    'Remarks', w5,
                    'CostMethodId', w1
                ]);
            }
        }
    }
}
